// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2C7vo","iconWrap":"styles_iconWrap__cB6Tl"};
module.exports.__checksum = "e61cb115483f"
